// extracted by mini-css-extract-plugin
export default {"innerNotesRow":"innerNotesRow-GhRvi","notesContainer":"notesContainer-nltQH","summarySeparator":"summarySeparator-J3vy8","notesList":"notesList-Yoxsu"};